import { EventCategoryEnergyPreference } from '@demind-inc/core';

export const MARKETING_SURVEY_OPTIONS = [
  {
    id: 'youtube',
    label: 'YouTube',
    isCustomInput: true,
    placeholder: 'Channel name (if you remember)',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    isCustomInput: true,
    placeholder: 'Username (if you remember)',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    isCustomInput: true,
    placeholder: 'Account or post (if you remember)',
  },
  {
    id: 'reddit',
    label: 'Reddit',
  },
  {
    id: 'app_play_store',
    label: 'App/Play Store',
    isCustomInput: true,
    placeholder: 'Search keyword (if you remember)',
  },
  {
    id: 'google_search',
    label: 'Google Search',
  },
  {
    id: 'friend',
    label: 'Friend',
  },
  {
    id: 'medium',
    label: 'Medium',
  },
  {
    id: 'ai',
    label: 'AI (ChatGPT, Gemini, Claude, etc.)',
  },
  {
    id: 'newsletter',
    label: 'Newsletter',
  },
  {
    id: 'facebook',
    label: 'Facebook',
  },
  {
    id: 'x',
    label: 'X',
  },
  {
    id: 'other',
    label: 'Other',
    isCustomInput: true,
    placeholder: 'Please specify',
  },
];

export type MarketingSurveyOption = (typeof MARKETING_SURVEY_OPTIONS)[number];

export const JOB_OPTIONS = [
  {
    id: 'software_engineer',
    label: 'Software Engineer',
  },
  {
    id: 'data_scientist',
    label: 'Data Scientist',
  },
  {
    id: 'product_manager',
    label: 'Product Manager',
  },
  {
    id: 'project_manager',
    label: 'Project Manager',
  },
  {
    id: 'ux_ui_designer',
    label: 'UX/UI Designer',
  },
  {
    id: 'devops_engineer',
    label: 'DevOps Engineer',
  },
  {
    id: 'machine_learning_engineer',
    label: 'Machine Learning Engineer',
  },
  {
    id: 'cybersecurity_specialist',
    label: 'Cybersecurity Specialist',
  },
  {
    id: 'it_support_specialist',
    label: 'IT Support Specialist',
  },
  {
    id: 'hardware_engineer',
    label: 'Hardware Engineer',
  },
  {
    id: 'business_analyst',
    label: 'Business Analyst',
  },
  {
    id: 'management_consultant',
    label: 'Management Consultant',
  },
  {
    id: 'investment_banker',
    label: 'Investment Banker',
  },
  {
    id: 'venture_capitalist',
    label: 'Venture Capitalist',
  },
  {
    id: 'private_equity_associate',
    label: 'Private Equity Associate',
  },
  {
    id: 'financial_analyst',
    label: 'Financial Analyst',
  },
  {
    id: 'accountant',
    label: 'Accountant',
  },
  {
    id: 'auditor',
    label: 'Auditor',
  },
  {
    id: 'marketing_manager',
    label: 'Marketing Manager',
  },
  {
    id: 'sales_representative',
    label: 'Sales Representative',
  },
  {
    id: 'growth_marketer',
    label: 'Growth Marketer',
  },
  {
    id: 'customer_success_manager',
    label: 'Customer Success Manager',
  },
  {
    id: 'physician',
    label: 'Physician',
  },
  {
    id: 'nurse',
    label: 'Nurse',
  },
  {
    id: 'pharmacist',
    label: 'Pharmacist',
  },
  {
    id: 'dentist',
    label: 'Dentist',
  },
  {
    id: 'therapist',
    label: 'Therapist (Mental Health Counselor, Psychologist)',
  },
  {
    id: 'physical_therapist',
    label: 'Physical Therapist',
  },
  {
    id: 'health_coach',
    label: 'Health Coach',
  },
  {
    id: 'medical_researcher',
    label: 'Medical Researcher',
  },
  {
    id: 'veterinarian',
    label: 'Veterinarian',
  },
  {
    id: 'teacher',
    label: 'Teacher (Elementary, Middle, High School)',
  },
  {
    id: 'university_professor',
    label: 'University Professor',
  },
  {
    id: 'education_administrator',
    label: 'Education Administrator',
  },
  {
    id: 'academic_researcher',
    label: 'Academic Researcher',
  },
  {
    id: 'tutor',
    label: 'Tutor',
  },
  {
    id: 'curriculum_developer',
    label: 'Curriculum Developer',
  },
  {
    id: 'writer_author',
    label: 'Writer / Author',
  },
  {
    id: 'journalist',
    label: 'Journalist',
  },
  {
    id: 'editor',
    label: 'Editor',
  },
  {
    id: 'copywriter',
    label: 'Copywriter',
  },
  {
    id: 'content_creator',
    label: 'Content Creator',
  },
  {
    id: 'photographer',
    label: 'Photographer',
  },
  {
    id: 'videographer',
    label: 'Videographer',
  },
  {
    id: 'graphic_designer',
    label: 'Graphic Designer',
  },
  {
    id: 'art_director',
    label: 'Art Director',
  },
  {
    id: 'social_media_manager',
    label: 'Social Media Manager',
  },
  {
    id: 'lawyer',
    label: 'Lawyer',
  },
  {
    id: 'paralegal',
    label: 'Paralegal',
  },
  {
    id: 'judge',
    label: 'Judge',
  },
  {
    id: 'government_official',
    label: 'Government Official',
  },
  {
    id: 'diplomat',
    label: 'Diplomat',
  },
  {
    id: 'policy_analyst',
    label: 'Policy Analyst',
  },
  {
    id: 'urban_planner',
    label: 'Urban Planner',
  },
  {
    id: 'architect',
    label: 'Architect',
  },
  {
    id: 'military_personnel',
    label: 'Military Personnel',
  },
  {
    id: 'law_enforcement_officer',
    label: 'Law Enforcement Officer',
  },
  {
    id: 'electrician',
    label: 'Electrician',
  },
  {
    id: 'plumber',
    label: 'Plumber',
  },
  {
    id: 'mechanic',
    label: 'Mechanic',
  },
  {
    id: 'carpenter',
    label: 'Carpenter',
  },
  {
    id: 'construction_worker',
    label: 'Construction Worker',
  },
  {
    id: 'machinist',
    label: 'Machinist',
  },
  {
    id: 'hvac_technician',
    label: 'HVAC Technician',
  },
  {
    id: 'welder',
    label: 'Welder',
  },
  {
    id: 'chef',
    label: 'Chef',
  },
  {
    id: 'restaurant_manager',
    label: 'Restaurant Manager',
  },
  {
    id: 'hotel_manager',
    label: 'Hotel Manager',
  },
  {
    id: 'event_planner',
    label: 'Event Planner',
  },
  {
    id: 'flight_attendant',
    label: 'Flight Attendant',
  },
  {
    id: 'travel_agent',
    label: 'Travel Agent',
  },
  {
    id: 'customer_service_representative',
    label: 'Customer Service Representative',
  },
  {
    id: 'bartender',
    label: 'Bartender',
  },
  {
    id: 'biologist',
    label: 'Biologist',
  },
  {
    id: 'chemist',
    label: 'Chemist',
  },
  {
    id: 'physicist',
    label: 'Physicist',
  },
  {
    id: 'environmental_scientist',
    label: 'Environmental Scientist',
  },
  {
    id: 'research_scientist',
    label: 'Research Scientist',
  },
  {
    id: 'geologist',
    label: 'Geologist',
  },
  {
    id: 'lab_technician',
    label: 'Lab Technician',
  },
  {
    id: 'actor',
    label: 'Actor',
  },
  {
    id: 'musician',
    label: 'Musician',
  },
  {
    id: 'dancer',
    label: 'Dancer',
  },
  {
    id: 'visual_artist',
    label: 'Visual Artist',
  },
  {
    id: 'film_director',
    label: 'Film Director',
  },
  {
    id: 'game_designer',
    label: 'Game Designer',
  },
  {
    id: 'founder',
    label: 'Founder',
  },
  {
    id: 'startup_employee',
    label: 'Startup Employee',
  },
  {
    id: 'small_business_owner',
    label: 'Small Business Owner',
  },
  {
    id: 'freelancer',
    label: 'Freelancer',
  },
  {
    id: 'consultant',
    label: 'Consultant',
  },
  {
    id: 'student',
    label: 'Student',
  },
  {
    id: 'retired',
    label: 'Retired',
  },
  {
    id: 'unemployed',
    label: 'Unemployed',
  },
  {
    id: 'homemaker',
    label: 'Homemaker',
  },
  {
    id: 'volunteer',
    label: 'Volunteer',
  },
  {
    id: 'nonprofit_worker',
    label: 'Nonprofit Worker',
  },
  {
    id: 'other',
    label: 'Other',
  },
];

export type JobOptions = (typeof JOB_OPTIONS)[number];

export const defaultEnergyPref: EventCategoryEnergyPreference[] = [
  { categoryId: 'default_deepWork', categoryName: 'Deep work', level: 'less_energized' },
  { categoryId: 'default_lightTask', categoryName: 'Light tasks', level: 'about_same' },
  { categoryId: 'default_exercise', categoryName: 'Exercise', level: 'more_energized' },
  { categoryId: 'default_mtg', categoryName: 'Meetings', level: 'less_energized' },
  { categoryId: 'default_social', categoryName: 'Social events', level: 'more_energized' },
];

export const ENERGY_PREF_TOOLTIP_TEXT = {
  default_deepWork:
    ' Tasks that require focus, attention, and creativity. This should be done in high energy!',
  default_lightTask:
    'Easier tasks like administrative work and chores. You do these in any zone, but prioritize deep work in high energy.',
};
